import { render, staticRenderFns } from "./PotentialHighNetWorth.vue?vue&type=template&id=69aff238"
import script from "./PotentialHighNetWorth.vue?vue&type=script&lang=js"
export * from "./PotentialHighNetWorth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports